<template>
    <main-table-layout
        sub-menu-selector="librarypanel"
    >
        <div slot="buttonsRight"/>
        <content-filter
                slot="filter"
                id="mediaList"
                @filter="filtering"
                store-name="Media"
                :category-filter-items="Object.keys(mediaCategories)"
                :category-filter-values="Object.values(mediaCategories)"
                :category-filter-exclude-values="$store.getters.isSuperAdmin ? [] : [0]"
        />
        <view-switcher
                slot="mainContentButtons"
                :id="'mainContent'"
                :table="true"
                :thumbnails="true"
        />
        <pagination
                slot="mainContentButtons"
                :limit="15"
                :total="$store.getters.getMediaListOptions(listName, 'pagination_items')"
                :id="'mediatablepage'"
                @setActive="loadPaginatedData"
                ref="pagination"
        />
        <Button
            permission="create"
            type="action-button" slot="mainContentButtons" link="/library/media/add" icon="plus">
            {{ $t('createNewMedia') }}
        </Button>
      <Button
           slot="mainContent"
           @click="loadPaginatedData(0); $refs.pagination.setActive(0)"
           type="reload"
           icon="redo"
           class="icon-button"
       />
        <table-widget
                v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'table'"
                slot="mainContent"
                :id="'mediaDefaultTable'"
                :nav-by-clicking-row="true"
                :deletable="true"
                @deleteRow="deleteRow"
                :show-tags="true"
                :show-organization="true"
                edit-permission="write"
                delete-permission="delete"
                :fields="tableFields"
                :data="$store.getters.getMediasByListName(listName)"
                :title-as-links="true"
                :use-team-permission="true"
                :loading="loading"
                 @sort="sort"
        />
        <thumbnails
                v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'thumbnails'"
                slot="mainContent"
                :id="'mediaDefaultTable'"
                :deletable="true"
                :nav-by-clicking-row="true"
                edit-permission="write"
                delete-permission="delete"
                :fields="thumbnailFields"
                :data="$store.getters.getMediasByListName(listName)"
                :title-as-links="true"
                :use-team-permission="true"
                :loading="loading"
                 @sort="sort"
        />
</main-table-layout>
</template>

<script>
    import Button from "../components/forms/Button";
    import TableWidget from "../components/widgets/TableWidget";
    import ContentFilter from "../components/widgets/filter/ContentFilter";
    import MainTableLayout from "../layouts/MainTableLayout";
    import ViewSwitcher from "../components/widgets/ViewSwitcher";
    import Thumbnails from "../components/widgets/ThumbnailView";
    import Pagination from "../components/Pagination";
    import FileTypeMixin from '@/components/files/FileTypeMixin.js';

    export default {
        name: "Media",
        components: {
            Button,
            TableWidget,
            ContentFilter,
            MainTableLayout,
            ViewSwitcher,
            Thumbnails,
            Pagination,
        },
        mixins: [
            FileTypeMixin
        ],
        data() {
            return {
                loading: true,
                filter: {},
                offset: 0,
                listName: 'MediaList',
                paginationLimit: 15,
                queryRelevantComponents: 2, //pagination and filter
                queryRelevantInits: 0,
                sorting: '-updatedAt',
                thumbnailFields: [

                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Organization',
                        id:'organization',
                        type: 'organization',
                        sortable: true
                    },
                    {
                        name: 'Type',
                        id:'type',
                        type: 'string',
                        translate: true,
                        translateFn: (f,i) => `mediaCategory.${i.mediaCategory}`,
                        sortable: true
                    },
                    {
                        name: 'Last Update',
                        id:'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Name',
                        id:'name',
                        type: 'string',
                        sortable: true
                    },
                    {
                      name: 'Teams',
                      id: 'teams',
                      type: 'teams',
                      sortable: true
                    },
                    {
                        name: 'Tags',
                        id:'tags',
                        type: 'tags',
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
                tableFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Name',
                        id:'name',
                        type: 'string',
                        sortable: true
                    },
                    {
                      name: 'Teams',
                      id: 'teams',
                      type: 'teams',
                      sortable: true
                    },
                    {
                        name: 'Type',
                        id:'type',
                        type: 'string',
                        translate: true,
                        translateFn: (f,i) => `mediaCategory.${i.mediaCategory}`,
                        sortable: true
                    },
                    {
                        name: 'Last Update',
                        id:'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
            }
        },
        watch: {
            queryRelevantInits: function(val) {
                if(val === this.queryRelevantComponents) {
                    this.loadPaginatedData(0);
                }
            }
        },
        beforeMount() {
          if(this.$store.getters.isSuperAdmin) {
            this.mediaCategories.application = 0;
          }
        },
        methods: {
            loadPaginatedData(offset, initial) {
              this.offset = offset;
              this.loadData(initial);
            },
            loadData(initial = false) {
              this.loading = true;
              let args = {
                  listName: this.listName,
                 }
                  const paginationAddOn = {
                    paging: {
                      [this.listName]: true,
                    },
                    offset: {
                      [this.listName]: this.offset,
                    },
                    limit: {
                      [this.listName]: this.paginationLimit,
                    },
                    include: {
                      [this.listName]: 'tags,teams',
                    },
                    sort: {
                      [this.listName]: this.sorting,
                    }
                  };
                  args.add = this.filter && this.filter.add ? {...paginationAddOn, ...this.filter.add } : paginationAddOn;
                  if(this.filter.remove) {
                    args.remove = {...this.filter.remove};
                  }
                if(initial) {
                    this.queryRelevantInits++;
                    this.$store.dispatch('registerMediaQueryParams', {listName: this.listName, params: args});
                }
                else {
                  this.$store.dispatch('loadMedias', args).then(() => {
                    this.loading = false;
                  });
                }
            },
            deleteRow: function(id) {
                this.$store.dispatch('deleteMedia', [id]).then(() => {
                  this.loadData();
                });
            },
            filtering: function(args, initial) {
              this.filter = args;
              this.loadData(initial);
            },
           sort(args) {
              const {fieldname, direction} = args;
              const sortString = direction + fieldname;
              if(this.sorting !== sortString) {
                this.sorting = sortString;
              }
              this.loadData(false);
            }
        }
    }
</script>
